// Top-level setup-page orchestrator. Owns:
//   - Navigation (Install / Select print method tabs)
//   - OS-specific install instructions (Windows vs Mac tab activation)
//   - Wiring the connection status state machine via initStatusPanel
//
// The state machine itself, the connectivity probe, and the failure-UX
// rendering each live in their own modules. Keeping this file small
// makes it easy to see at a glance how the page boots.

import { initStatusPanel } from "./chit_chats_print_agent_setup_status";

function isMacPlatform() {
  return ["Macintosh", "MacIntel", "MacPPC", "Mac68K"].indexOf(window.navigator.platform) >= 0;
}

function activateOSTab(container) {
  var os = isMacPlatform() ? "mac" : "windows";
  var tabs = container.querySelectorAll(".js-chit-chats-print-os-tabs .nav-link");
  var panes = container.querySelectorAll(".js-chit-chats-print-os-tab-content .tab-pane");

  tabs.forEach(function(tab) {
    tab.classList.toggle("active", tab.getAttribute("href") === "#" + os);
  });
  panes.forEach(function(pane) {
    pane.classList.toggle("active", pane.id === os);
  });
}

function bindNextButtons(container) {
  container.addEventListener("click", function(event) {
    var button = event.target.closest(".js-chit-chats-print-next-btn");
    if (!button) {
      return;
    }
    var tab = document.querySelector(button.dataset.tab);
    if (tab) {
      tab.click();
    }
  });
}

function activateSelectPrinterFromHash() {
  if (window.location.hash !== "#select-printer") {
    return;
  }
  var selectPrinterTab = document.querySelector("#select-printer-tab");
  if (selectPrinterTab) {
    selectPrinterTab.click();
  }
}

function initializeNavigation() {
  var container = document.querySelector(".js-chit-chats-print-setup");
  if (!container || container.dataset.navigationInitialized === "true") {
    return;
  }

  activateOSTab(container);
  bindNextButtons(container);
  container.dataset.navigationInitialized = "true";

  activateSelectPrinterFromHash();
}

const ChitChatsPrintSetupPage = {
  init() {
    initStatusPanel();
  }
};

function initializeChitChatsPrintSetupPage() {
  initializeNavigation();
  ChitChatsPrintSetupPage.init();
}

document.addEventListener("DOMContentLoaded", initializeChitChatsPrintSetupPage);
document.addEventListener("turbolinks:load", initializeChitChatsPrintSetupPage);

export { ChitChatsPrintSetupPage };
